import { gatewayMatchesProjectKey } from '@modules/project-keys/utils/gatewayMatchesProjectKey'

import { GATEWAY_LIST_FILTER_ALL } from '../constants/gatewayListFilters.const'
import type { GatewayListFilterFormSlice, GatewayListFilterTraitsSource } from '../types/gatewayListFilters.types'

import { resolveGatewayListFilterTraits, resolveGatewayListHostedModuleNames } from './resolveGatewayListFilterTraits'

export function applyGatewayListFilters<T extends GatewayListFilterTraitsSource>(
  items: T[],
  filters: GatewayListFilterFormSlice
): T[] {
  const searchTerm = filters.search?.trim().toLowerCase() ?? ''

  return items.filter((item) => {
    const traits = resolveGatewayListFilterTraits(item)

    if (filters.status !== GATEWAY_LIST_FILTER_ALL && traits.status !== filters.status) {
      return false
    }

    if (filters.runtime !== GATEWAY_LIST_FILTER_ALL && traits.runtime !== filters.runtime) {
      return false
    }

    if (filters.feed !== GATEWAY_LIST_FILTER_ALL) {
      const selectedModule = filters.feed.trim().toLowerCase()
      const hostedNames = resolveGatewayListHostedModuleNames(item).map((name) => name.toLowerCase())
      if (!hostedNames.includes(selectedModule)) {
        return false
      }
    }

    if (filters.projectKey !== GATEWAY_LIST_FILTER_ALL && !gatewayMatchesProjectKey(item, filters.projectKey)) {
      return false
    }

    if (searchTerm) {
      const searchable = [traits.displayName, ...resolveGatewayListHostedModuleNames(item)].join(' ').toLowerCase()
      if (!searchable.includes(searchTerm)) {
        return false
      }
    }

    return true
  })
}
